import React, { useRef, useEffect, useState } from 'react'

const Collapsible = ({
  children,
  in: inProp = false,
  timeout = 300,
  className = '',
  style = {},
  ...props
}) => {
  const contentRef = useRef(null)
  const wrapperRef = useRef(null)
  const [height, setHeight] = useState(inProp ? 'auto' : '0px')

  useEffect(() => {
    const wrapper = wrapperRef.current
    const content = contentRef.current

    if (!wrapper || !content) {
      return
    }

    let timer

    if (inProp) {
      setHeight('0px')

      requestAnimationFrame(() => {
        const contentHeight = content.scrollHeight
        setHeight(`${contentHeight}px`)

        timer = setTimeout(() => {
          setHeight('auto')
        }, timeout)
      })
    } else {
      const currentHeight = content.scrollHeight

      timer = setTimeout(() => {
        setHeight(`${currentHeight}px`)

        requestAnimationFrame(() => {
          setHeight('0px')
        })
      }, timeout)
    }

    return () => {
      if (timer) {
        clearTimeout(timer)
      }
    }
  }, [inProp, timeout])

  return (
    <div
      ref={wrapperRef}
      className={className}
      style={{
        height: height,
        overflow: 'hidden',
        transition: `height ${timeout}ms cubic-bezier(0.4, 0, 0.2, 1)`,
        width: '100%',
        ...style
      }}
      {...props}
    >
      <div ref={contentRef}>{children}</div>
    </div>
  )
}

export default Collapsible
